import type { AppType } from '@utilities-one/api-sdk';
import { DetailedError, hc, parseResponse } from 'hono/client';

import { getClientApiUrl } from '@/config/getEnv';
import { redirectToLoginOn401 } from '@/library/api/redirectToLoginOn401';

/**
 * Typed Hono RPC client for `/api/v2` routes (see gpm-api-v2 `AppType`).
 * Always wrap RPC calls with {@link parseResponse} so errors throw {@link DetailedError}
 * and the promise resolves to the parsed body.
 */
const api = hc<AppType>(`${getClientApiUrl()}/api/v2`, {
  init: {
    credentials: 'include',
  },
  fetch: (input: RequestInfo | URL, init?: RequestInit) => fetch(input, init).then(redirectToLoginOn401),
});

export { api, DetailedError, parseResponse };
